
























































































































import { Component, Vue } from 'vue-property-decorator'
import {
  BRow,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormCheckboxGroup,
  BSidebar,
  BButton,
  BIconFunnel,
  VBToggle
} from 'bootstrap-vue'
import chunk from 'lodash/chunk'
import forEach from 'lodash/forEach'
import uniq from 'lodash/uniq'
import uniqBy from 'lodash/uniqBy'
import map from 'lodash/map'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import intersectionWith from 'lodash/intersectionWith'
import find from 'lodash/find'
import filter from 'lodash/filter'
import includes from 'lodash/includes'

import { app } from '../main'
import ProductsApi from '@cms-labs/typescript-api/products'
import SearchApi from '@cms-labs/typescript-api/search'
import ProductCollectionItem from '@/components/products/ProductCollectionItem.vue'
import {
  ProductCollectionItemPublic,
  ProductAttributeValues,
  ProductAttribute, ProductType, ProductCategory
} from '@cms-labs/typescript-api/products/types'

import BreadCrumb from '@/components/BreadCrumb.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import { emptyProductCategoryInstance, emptyProductTypeInstance } from '@cms-labs/typescript-api/products/constants'

Vue.directive('b-toggle', VBToggle)

@Component({
  components: {
    BRow,
    BCol,
    BSidebar,
    ProductCollectionItem,
    BreadCrumb,
    LoadingOverlay,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BButton,
    BIconFunnel
  }
})
export default class ProductCollection extends Vue {
  private isLoading = false
  private isOnMobile = window.innerWidth < 992
  public productType: ProductType | undefined = emptyProductTypeInstance
  public productCategory: ProductCategory | null | undefined
    = emptyProductCategoryInstance

  public selectedFilters: ProductAttribute[] = []
  public selectedCategories: string[] = []
  public products: ProductCollectionItemPublic[] = []
  public isSearchPage = false
  private productTypes!: ProductType[] | undefined

  mounted () {
    window.addEventListener('resize', this.onResize)
  }

  private async created (): Promise<void> {
    this.isLoading = true
    // Check if this is a search page first
    if (this.$route.path === '/q/search') {
      this.isSearchPage = true
      const http = new SearchApi(app)
      try {
        const query = this.$route.query.q
        // @ts-ignore
        const resp = await http.searchProducts(query)
        this.products = resp
        this.isLoading = false
        return
      } catch (error) { this.isLoading = false }
    }

    try {
      const http = new ProductsApi(app)
      this.productTypes = await http.getProductTypeCollection()
      const resp = await http.getProductCollection(
        this.$route.params.productType,
        this.$route.params.productCategory,
        null,
        null
      )
      if (resp) {
        this.products = resp
        this.productType = find(
          this.productTypes,
          ['name', this.products[0].type]
        )
        if (this.$route.params.productCategory) {
          this.productCategory = find(
            this.productType?.categories,
            ['name', this.products[0].category]
          )
        } else this.productCategory = null
      }
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  onResize () {
    if (window.innerWidth <= 875) {
      this.isOnMobile = true
    } else {
      this.isOnMobile = false
    }
  }

  private get collectionColWidth () {
    return this.isOnMobile ? 12 : 9
  }

  private getArrayChunks (
    inputArray: ProductCollectionItemPublic[],
    chunkSize: number
  ): ProductCollectionItemPublic[][] {
    return chunk(inputArray, chunkSize)
  }

  private getAttrObject (key: string, value: string): ProductAttribute {
    return { key: key, value: value }
  }

  private joinSameKeyAttrs (arr: ProductAttribute[]): ProductAttributeValues[] {
    // Returns array of key:values for same-key attrs.
    // Ex.: [{key: a, value: 5}, {key: a, value: 10}] => [{ key: a, values: [5, 10] }]
    // Get all attributes with unique (non-duplicated) key:value pairs
    const uniqAttrPairs = uniqBy(
      arr,
      (attr) => { return `${attr.key}:${attr.value}` }
    )
    // Get all unique keys
    const uniqAttrKeys = map(
      uniqBy(uniqAttrPairs, (attr) => { return `${attr.key}` }),
      'key'
    )

    // Generate initial attr objects and add attr keys
    // Then, and add attr values to existing attr objects
    const productAttrs: ProductAttributeValues[] = []
    forEach(uniqAttrKeys, (key) => {
      const values: string[] = []
      forEach(uniqAttrPairs, (attr) => {
        if (attr.key === key) {
          values.push(attr.value)
        }
      })
      productAttrs.push({ key: key, values: uniq(values) })
    })
    return productAttrs
  }

  private productHasAnyOfFilterValues (
    product: ProductCollectionItemPublic,
    filterValues: ProductAttributeValues
  ): boolean {
    const sameKeyFiltersArray: ProductAttribute[] = []
    forEach(filterValues.values, (value) => {
      sameKeyFiltersArray.push(
        {
          key: filterValues.key,
          value: value
        }
      )
    })
    if (!isEmpty(intersectionWith(product.attributes, sameKeyFiltersArray, isEqual))) {
      return true
    }
    return false
  }

  private get filteredProducts (): ProductCollectionItemPublic[] {
    /* The filter works in an (AND / OR) specific way:
    Returned products must have any-of the values given for a specific filter key
    but they must accomplish this for all-of the keys.

    Our two forEach loops check each set of same-key applied filters
    against each product. If the product has none of the options for a
    given key, then it is filtered out. */
    if (
      isEmpty(this.selectedFilters) &&
      isEmpty(this.selectedCategories)
    ) {
      return this.products
    }
    const filteredProds: ProductCollectionItemPublic[] = []
    const appliedFilters = this.joinSameKeyAttrs(this.selectedFilters)
    let broken = false
    forEach(this.categoryProducts, (product) => {
      broken = false
      forEach(appliedFilters, (filter) => {
        if (broken) { return }
        if (!this.productHasAnyOfFilterValues(product, filter)) { broken = true }
      })
      // Check it is not added already and it is not "broken"
      if (!broken && !find(filteredProds, product)) {
        filteredProds.push(product)
      }
    })
    return filteredProds
  }

  private get productAttributes (): ProductAttributeValues[] {
    const allAttrs: ProductAttribute[] = []
    forEach(this.products, (product) => {
      if (!isEmpty(product.attributes)) {
        forEach(product.attributes, (attr) => {
          allAttrs.push(attr)
        })
      }
    })
    return this.joinSameKeyAttrs(allAttrs)
  }

  private get productTypeCategories (): string[] {
    const allCategories: string[] = []
    forEach(this.products, (product) => {
      allCategories.push(product.category)
    })
    return uniq(allCategories)
  }

  private get categoryProducts (): ProductCollectionItemPublic[] {
    if (!isEmpty(this.selectedCategories)) {
      return filter(this.products, (product) => {
        return includes(this.selectedCategories, product.category)
      })
    }
    return this.products
  }
}
